import React, { Fragment } from 'react'

import HorizontalContainer from '../../components/HorizontalContainer'
import ProfileSidebar from '../../components/ProfileSidebar'

import SkeletonEmploymentPreferences from '../SkeletonEmploymentPreferences'
import SkeletonLocationPreferences from '../SkeletonLocationPreferences'
import SkeletonNextJob from '../SkeletonNextJob'
import SkeletonWorkAuthorisation from '../SkeletonWorkAuthorisation'
import SkeletonPersonalInformation from '../SkeletonPersonalInformation'
import SkeletonSidebar from '../SkeletonSidebar'
import SkeletonStatusInfoCard from '../SkeletonStatusInfoCard'

import styles from './styles'

const SkeletonCandidateProfileScene = () => (
  <Fragment>
    <HorizontalContainer>
      <div className={styles.sideContent}>
        <SkeletonPersonalInformation />
        <SkeletonEmploymentPreferences />
        <SkeletonLocationPreferences />
        <SkeletonWorkAuthorisation />
        <SkeletonNextJob />
      </div>

      <ProfileSidebar>
        <SkeletonStatusInfoCard />
        <SkeletonSidebar />
      </ProfileSidebar>
    </HorizontalContainer>
  </Fragment>
)

export default SkeletonCandidateProfileScene
